import { Box, Button, Container, Typography } from "@mui/material";
import React from "react";
import bgImage from "../assets/img/bgImage-1.png"
const HeroSection = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "850px",
        backgroundColor: "#1e1e1e",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl" sx={{ height: "100%", position: "relative" }}>
        <Box
          sx={{
            position: "relative",
            display: "flex",
            height: "100%",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Left content */}
          <Box sx={{ maxWidth: "407px" }}>
            <Typography
              variant="h3"
              sx={{
                fontFamily: "'Spline_Sans_Mono-SemiBoldItalic', Helvetica",
                fontWeight: 600,
                fontStyle: "italic",
                color: "#fefefe",
                fontSize: "38px",
                lineHeight: "45.3px",
                mb: 3,
              }}
            >
              Trusted by Industry Leaders
            </Typography>

            <Typography
              sx={{
                fontFamily: "'Space_Grotesk-Medium', Helvetica",
                fontWeight: 500,
                color: "#a2a2a1",
                fontSize: "18px",
                lineHeight: "29.7px",
                mb: 5,
              }}
            >
              Our secure data transfer and web storage service has earned the
              trust of top companies across various industries, ensuring the
              smooth and secure migration of their critical files
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#ffd840",
                color: "#7a6332",
                borderRadius: "60px",
                width: "189px",
                height: "60px",
                textTransform: "none",
                fontFamily: "'Inter-Regular', Helvetica",
                fontSize: "17px",
                fontWeight: 400,
                "&:hover": {
                  backgroundColor: "#e6c339",
                },
              }}
            >
              Learn More
            </Button>
          </Box>

          {/* Right image */}
          <Box
            sx={{
              width: "639px",
              height: "639px",
              position: "relative",
            }}
          >
            <Box
              sx={{
                height: "100%",
                backgroundImage: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "50% 50%",
                position: "relative",
                display: {xs: "none",sm:"flex"}
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  width: "131px",
                  height: "41px",
                  top: "251px",
                  left: "84px",
                  transform: "rotate(6.28deg)",
                  backgroundColor: "#fefdfd",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  width: "131px",
                  height: "41px",
                  top: "92px",
                  left: "255px",
                  transform: "rotate(-13.59deg)",
                  backgroundColor: "#fefdfd",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;